import { Reducer } from 'redux'
import { ICarrierApplication } from 'types'
import { IMarketplaceStore } from 'apps/marketplace/store/types'
import { CARRIER_APPLICATION_ACTION_TYPES as c } from './actions'
import { ICarrierApplicationState } from './types'

const defaultState = {
  data: undefined,
  isLoading: false,
  error: '',
}

type CarrierApplicationActions =
  | { type: c.FETCH_CARRIER_APPLICATION_REQUEST }
  | {
      type: c.FETCH_CARRIER_APPLICATION_SUCCESS
      payload: { carrierApplication: ICarrierApplication }
    }
  | { type: c.FETCH_CARRIER_APPLICATION_FAILURE; error: string }

const carrierApplicationReducer: Reducer<ICarrierApplicationState, CarrierApplicationActions> = (
  state: ICarrierApplicationState = defaultState,
  action: CarrierApplicationActions
): ICarrierApplicationState => {
  switch (action.type) {
    case c.FETCH_CARRIER_APPLICATION_REQUEST:
      return {
        ...state,
        isLoading: true,
      }
    case c.FETCH_CARRIER_APPLICATION_SUCCESS: {
      const { carrierApplication: data } = action.payload
      return {
        ...state,
        isLoading: false,
        data,
      }
    }
    case c.FETCH_CARRIER_APPLICATION_FAILURE: {
      const { error } = action
      return {
        ...state,
        isLoading: false,
        error,
      }
    }
    default:
      return state
  }
}

export default carrierApplicationReducer

export const selectCarrierApplication = (
  state: IMarketplaceStore
): ICarrierApplication | undefined => state.carrierApplication?.data
